module.exports = "/_next/static/images/open-data-open-source-19d28128db15731531f7b6760883b9a7.jpg";